import { useSelector } from 'react-redux';

import * as selectors from 'pages/company-profile/controllers/selectors';

export const useGetMemberInfo = () => {
  const memberInfo = useSelector(selectors.selectMemberProfile());

  return { memberInfo };
};
